import * as React from "react"

function EspecialistaIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12.62 15.19"
      {...props}
    >
      <defs>
        <style>{".cls-1{fill:#003da6}"}</style>
      </defs>
      <g id="Capa_2" data-name="Capa 2">
        <g id="Capa_1-2" data-name="Capa 1">
          <path
            className="cls-1"
            d="M6.31 1.32a1.93 1.93 0 00-1.89 2 1.93 1.93 0 001.89 2 1.93 1.93 0 001.89-2 1.93 1.93 0 00-1.89-2m0 5.28a3.23 3.23 0 01-3.16-3.3A3.24 3.24 0 016.31 0a3.23 3.23 0 013.15 3.3 3.22 3.22 0 01-3.15 3.3M1.26 13.87h10.1v-1.32a3.88 3.88 0 00-3.79-4H5.05a3.88 3.88 0 00-3.79 4zM12 15.19H.63a.65.65 0 01-.63-.66v-2a5.17 5.17 0 015.05-5.27h2.52a5.17 5.17 0 015 5.29v2a.65.65 0 01-.63.66"
          />
        </g>
      </g>
    </svg>
  )
}

export default EspecialistaIcon
